import React, { useState } from "react";
import {
	Create,
	SimpleForm,
	SelectInput,
	NumberInput,
	DateTimeInput,
	required
} from "react-admin";

const DiscountCodeCreate = ({ permissions, ...props }) => {
	return (
		<Create title="Discount Code" {...props}>
			<SimpleForm redirect="list">
				<SelectInput 
					source='type' 
					label="Code Type" 
					validate={[required()]}
					choices={[
						{ id: 'fixed', name: 'Fixed' },
						{ id: 'percentage', name: 'Percentage' }
					]}
				/>
				<NumberInput source="value" label="Value" validate={[required()]} />
				<DateTimeInput 
					source="expires_at" 
					label="Expires At" 
					validate={[required()]} 
				/>
				<NumberInput source="num" label="Num" validate={[required()]} />
			</SimpleForm>
		</Create>
	);
};

export default DiscountCodeCreate;
